import { render, staticRenderFns } from "./TraverPointList.vue?vue&type=template&id=4f4feef4"
import script from "./TraverPointList.vue?vue&type=script&lang=js"
export * from "./TraverPointList.vue?vue&type=script&lang=js"
import style0 from "./TraverPointList.vue?vue&type=style&index=0&id=4f4feef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports